
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.154.033a2.838 2.838 0 00-2.82 2.618C1.871 2.76.7 3.973.7 5.453v9.728c0 1.55 1.281 2.824 2.842 2.824h6.31a2.838 2.838 0 002.82-2.616c1.464-.109 2.635-1.322 2.635-2.802V5.232c0-.71-.27-1.394-.755-1.916L12.346.942a2.85 2.85 0 00-2.088-.909zm0 1.54h4.104c.361 0 .704.15.95.414l2.206 2.374c.22.238.343.548.343.871v7.355c0 .64-.453 1.156-1.062 1.262V7.825c0-.71-.269-1.394-.753-1.915L9.735 3.535a2.852 2.852 0 00-2.089-.907H4.884a1.275 1.275 0 011.27-1.055zm.98 2.596c-.017.49-.007 1-.007 1.498 0 1.55 1.282 2.824 2.843 2.824h1.174l-.024 6.92a1.273 1.273 0 01-1.267 1.053H3.542a1.276 1.276 0 01-1.292-1.283V5.453c0-.64.453-1.156 1.062-1.262zm1.544.497l2.12 2.285H9.97a1.276 1.276 0 01-1.292-1.284z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    